import { Form, Modal, ModalBody, ModalHeader } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  confirmationModal,
  setEditCredential,
} from "../../../slices/agMember/agMemberSlice";
import { Button, Col, Row } from "react-bootstrap";
import { getAgMemberData, updateCredentials } from "../AgMemberService";
import { useParams } from "react-router-dom";

const DetailsConfirmationModal = () => {
  const dispatch = useDispatch();

  const confirmationShow = useSelector(
    (state) => state.agMember.confirmationShow
  );
  const formState = useSelector((state) => state.common.formRendererState);
  const detailsData = useSelector(
    (state) => state.agMember.selectedAgMember.detailsData
  );
  const params = useParams();
  const mode = useSelector((state) => state.agMember.mode);
  const editCredential = useSelector((state) => state.agMember.editCredential);

  const handleClose = () => {
    dispatch(setEditCredential({}));
    dispatch(confirmationModal(false));
  };


  const updateClickHandler = async (e) => {
    e.preventDefault();
    await updateCredentials(
      formState.entityid,
      editCredential.mobileNumber || null,
      editCredential.emailId || null,
      editCredential.password || null,
      params.id,
      mode
    );
    dispatch(confirmationModal(false));
    dispatch(setEditCredential({}));
  };

  return (
    <Modal
      isOpen={confirmationShow}
      onHide={() => handleClose()}
      centered
      backdrop="static"
      keyboard={false}
      className="border-0"
      modalClassName="modal fade zoomIn"
      toggle={handleClose}
      size="lg"
    >
      <Form className="tablelist-form" onSubmit={updateClickHandler}>
        <ModalHeader className="p-3 bg-info-subtle" toggle={handleClose}>
          Confirm Credentials
        </ModalHeader>

        <ModalBody className="modal-body">
          <Row className="g-3">
            <Col lg={12}>
              <div className="confirmation-container">
                <div className="attention">Attention!</div>
                <div className="confirmation-msg">
                  Please note if you change credentials the user won’t be able
                  to login with the old credentials. Click on confirm to
                  continue.
                </div>
              </div>
            </Col>
            <Col lg={12}>
              <div className="hstack gap-2 justify-content-center">
                <Button
                  type="submit"
                  className="primary primary_button"
                  id="addNewMember"
                >
                  Confirm
                </Button>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Form>
    </Modal>
  );
};

export default DetailsConfirmationModal;
